<template>
  <div class="list" ref="list">
    <slot>
    </slot>
    <transition name="fade">
      <div v-if="value" class="loading">加载过程中</div>
      <div v-if="finished" class="loading">已经到底了</div>
    </transition>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: true
    },
    finished: {
      type: Boolean,
      default: false
    },
    el: {
      type: HTMLDivElement,
      default: () => null
    }
  },
  created () {
    // this.$emit('onload')
  },
  activated () {
    this.$nextTick(() => {
      this.$refs.list.scrollTop = this.getDynamicScroll
    })
  },
  // deactivated () {
  //   // 清除绑定的scroll事件
  //   this.$refs.list.removeEventListener('scroll', this.recordScrollPosition)
  // },
  destroyed () {
    this.$refs.list.removeEventListener('scroll', this.recordScrollPosition)
  },
  mounted () {
    this.$refs.list.addEventListener('scroll', this.recordScrollPosition, true)
    this.addUpRefresh()
  },
  methods: {
    recordScrollPosition (e) {
      this.$store.dispatch('BrowseCoord/setDynamicScroll', e.target.scrollTop)
      this.addUpRefresh()
    },
    addUpRefresh () {
      const el = this.el || this.$refs.list
      if (!el) {
        return
      }
      const offsetHeight = el.offsetHeight
      el.addEventListener('scroll', async () => {
        if (this.value || this.finished) {
          return
        }
        const scrollHeight = el.scrollHeight
        const scrollTop = el.scrollTop
        if (Math.ceil(offsetHeight + scrollTop) >= scrollHeight) {
          this.$emit('input', true)
          await this.$emit('onload')
        }
      })
    }
  },
  computed: {
    getDynamicScroll () {
      return this.$store.getters['BrowseCoord/getDynamicScroll']
    }
  }
}
</script>
<style lang="scss" scoped>
.list {
  height: 100%;
  overflow-y: scroll;
  background-color: #f5f5f5;
}
.bounce-enter-active {
  animation: bounce-in 1s;
}
.bounce-leave-active {
  animation: bounce-in 1s reverse;
}
@keyframes bounce-in {
  from {
    height: 0;
  }
  to {
    height: 50px;
  }
}
.loading {
    background: #fff;
    display: block;
    width: 100%;
    height: 50px;
    line-height: 50px;
    text-align: center;
}
</style>
